import api from '../api/axios';

export interface InstagramPost {
  id?: number;
  caption: string;
  mediaUrl?: string;
  mediaType?: 'image' | 'video' | 'carousel' | 'reel';
  postType?: 'feed' | 'story' | 'reel';
  status?: 'draft' | 'scheduled' | 'published' | 'failed';
  scheduledFor?: string;
  publishedAt?: string;
  instagramPostId?: string;
  permalink?: string;
  hashtags?: string[];
  mentions?: string[];
  likes?: number;
  comments?: number;
  reach?: number;
  impressions?: number;
  engagement?: number;
  createdBy?: any;
  errorMessage?: string;
  metadata?: any;
}

const InstagramService = {
  // Posts
  getAllPosts: (params?: any) => api.get('/instagram-posts', { params }),
  getPost: (id: number) => api.get(`/instagram-posts/${id}`, { params: { populate: '*' } }),
  createPost: (data: Partial<InstagramPost>) => api.post('/instagram-posts', { data }),
  updatePost: (id: number, data: Partial<InstagramPost>) =>
    api.put(`/instagram-posts/${id}`, { data }),
  deletePost: (id: number) => api.delete(`/instagram-posts/${id}`),
  
  // Publish
  publishPost: (id: number) =>
    api.post(`/instagram-posts/${id}/publish`),
  
  // Schedule
  schedulePost: (id: number, scheduledFor: string) =>
    api.post(`/instagram-posts/${id}/schedule`, { scheduledFor }),
  
  // Analytics
  getAnalytics: (startDate?: string, endDate?: string) =>
    api.get('/instagram-posts/analytics', { params: { startDate, endDate } }),
  
  // Insights
  refreshInsights: (id: number) =>
    api.post(`/instagram-posts/${id}/refresh-insights`),
};

export default InstagramService;

